package org.chiangmeng.qfast.core.ui.staff

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import org.chiangmeng.qfast.core.ui.theme.QFastTheme

data class StaffScreen(val shopId: String) : Screen {
    @Composable
    override fun Content() {
        val viewModel = koinScreenModel<StaffViewModel>()
        val state by viewModel.state.collectAsState()

        LaunchedEffect(shopId) {
            viewModel.handleIntent(StaffContract.Intent.LoadData(shopId))
        }

        QFastTheme(appTheme = state.currentTheme) {
            Box(modifier = Modifier.fillMaxSize()) {
                StaffDashboardScreen(
                    state = state,
                    onIntent = { intent -> viewModel.handleIntent(intent) }
                )
            }
        }
    }
}
